@if (showView) {
  <div class="floatover-container" [style.top.px]="styleTop" [style.left.px]="styleLeft">
    <div class="content-area">
      <div class="body">
        @if (loading) {
          <ion-spinner></ion-spinner>
        } @else {
          <div [innerHTML]="inputHtml"></div>
        }
      </div>
    </div>
  </div>
}
